<template>
  <div class="common-box border-t0 margin-l6">
    <el-row class="row-one">
      <span class="row-one-title">风险测评</span>
      <span class="row-one-fr" @click="$router.push({name:'riskAssessmentDescription', params:{pathName:'riskAssessment'}})">点击查看个人风险测评说明</span>
      <span></span>
    </el-row>
    <div class="riskAssess">
      <div class="riskAssess-title">
        <span>您是一位 <i class="aColor">{{riskName}}</i> 投资者</span>
        <el-button type="cancel" class="margin-l50" @click="againClick">重新测评</el-button>
      </div>
      <ul class="riskAssess-type clearfix font-blod  margin-t30">
        <li :class="{'active':item.level == riskLevel}" v-for="(item,i) in riskNameArr" :key="i">
          <span>{{item.leavlName}}</span>
          <!-- 浮标 -->
          <div v-show="item.level == riskLevel" class="cursor aColor">
            <div style="height: 45px;">您在此</div>
            <div class="icon"></div>
          </div>
        </li>
      </ul>
      <ul class="riskAssess-level">
        <li>
          <div class="circle"><span>低风险</span></div>
          <div class="line"></div>
        </li>
        <li>
          <div class="circle" style="background:#759FE1;"><span>低中风险</span></div>
          <div class="line"></div>
        </li>
        <li>
          <div class="circle" style="background:#7D7DE5;"><span>中风险</span></div>
          <div class="line"></div>
        </li>
        <li>
          <div class="circle" style="background:#4193D1;"><span>中高风险</span></div>
          <div class="line"></div>
        </li>
        <li>
          <div class="circle" style="background:#0074BF;"><span>高风险</span></div>
        </li>
      </ul>
      <div class="riskAssess-product margin-t50 font-blod">
        <p>适合购买的产品风险等级为：<span class="aColor">{{productLevel}}</span></p>
        <p class="margin-t20">适合购买的投资基金类型有：<span class="aColor">{{fundLevel}}</span></p>
      </div>
    </div>
    <!-- <img src="../../../assets/images/development.png" alt="" style="margin: 100px 480px;"> -->
  </div>

</template>

<script>
import $ from 'jquery'
export default {

  data () {
    return {
      riskLevel: '',
      riskName: '',
      riskNameArr: [
        {
          level: '01',
          leavlName: '极端保守型'
        }, {
          level: '02',
          leavlName: '相对稳健型'
        }, {
          level: '03',
          leavlName: '稳健平衡型'
        }, {
          level: '04',
          leavlName: '相对成长型'
        }, {
          level: '05',
          leavlName: '积极进取型'
        },
      ],
      productLevel: '',
      fundLevel: '',
    }
  },
  created () {
    const risk = this.$commonJs.getCookie('u_risk')
    this.riskLevel = risk == "0" ? "01" : risk
    this.riskName = this.$commonJs.getPersonalLevel(this.riskLevel)
  },
  mounted () {
    this.productLevel = this.$commonJs.getfundLevel(this.riskLevel)
    this.fundLevel = this.$commonJs.getFundType(this.riskLevel)
  },
  methods: {
    againClick () {
      this.$emit("func", false)
    }
  }
}
</script>

<style lang="less" scoped>
.riskAssess {
  position: relative;
  padding: 25px 50px;
  font-size: 16px;
  &-title {
    height: 80px;
    line-height: 80px;
  }
  &-type {
    height: 58px;
    background: #f7f7f7;
    li {
      position: relative;
      box-sizing: border-box;
      float: left;
      width: 20%;
      height: 58px;
      line-height: 58px;
      text-align: center;
      border: 1px solid #e4e4e4;
      border-right: none;
      color: @color6;
      .cursor {
        font-size: 14px;
        position: absolute;
        top: -51px;
        left: 66px;
        text-align: center;
        .icon {
          width: 0;
          height: 0;
          border-left: 7px solid transparent;
          border-right: 7px solid transparent;
          border-top: 7px solid #4293d2;
          // position: absolute;
          margin: 5px auto;
        }
      }
    }
    li:last-child {
      border-right: 1px solid #e4e4e4;
    }
  }
  &-level {
    margin-top: 40px;
    height: 80px;
    li {
      position: relative;
      width: 20%;
      float: left;
      text-align: center;
      line-height: 80px;
      .circle {
        width: 80px;
        height: 80px;
        background: #79c5e9;
        margin: auto;
        border-radius: 80px;
        font-weight: bold;
        color: @wColor;
      }
      .line {
        position: absolute;
        right: -30px;
        top: 38px;
        width: 68px;
        height: 2px;
        background: #79c5e9;
      }
    }
  }
  &-product {
    text-align: center;
    color: @color6;
  }
}
.active {
  background: #fff;
  border-bottom: none !important;
}
</style>


